/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { LinkRewardsProvider } from '@/components/LinkRewardsContext';
import { type StandaloneOnlineMergeModalsType } from '../interface';
import { StandaloneOnlineMergeModals } from './StandaloneOnlineMergeModals';

type StandaloneOnlineMergeFlowProps = {
  view: StandaloneOnlineMergeModalsType;
};

export const StandaloneOnlineMergeFlow = ({ view }: StandaloneOnlineMergeFlowProps) => {
  return (
    <LinkRewardsProvider>
      <StandaloneOnlineMergeModals view={view} />
    </LinkRewardsProvider>
  );
};
